import { API_LOCATION_URL } from 'infrastructure/config';
import { IBuyerUserLogoutClient, IPostInput } from 'interfaceAdapter/gatewaySchemas/IBuyerUserLogoutClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/user/logout`;

export class BuyerUserLogoutClient implements IBuyerUserLogoutClient {
    async post(input: IPostInput): Promise<void> {
        const { token } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        await fetch(PATH, { method, headers });
    }
}
